/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./ReadyToBegin.css";

export default function ReadyToBegin({ readyBegin }) {
  const imgCDN = process.env.REACT_APP_CDN_EQUO_DPA;
  return (
    <div>
      <Container className="ready-to-begin">
        <Row>
          <Col sm={12} md={12} lg={12} xl={12}>
           <h2>{readyBegin.heading}</h2>
           <p>{readyBegin.paragraph}</p>
          </Col>
        </Row>
        <Row >
          <Col sm={12} md={12} lg={12} xl={12} className="contact-col">
          
            <a href={"tel:" + readyBegin.phone.phoneWithIntCode}>{readyBegin.phone.phoneNumber}</a>
          </Col>
        
          <Col sm={12} md={12} lg={12} xl={12} className="contct ">
         
            <a href={readyBegin.email.emailUrl}>{readyBegin.email.emailAddress}</a>
          </Col>
          
        </Row>
      </Container>
 
    </div>
  );
}
